import { render } from "./Projects.vue?vue&type=template&id=832a2fe8"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"
script.render = render

export default script